import styled from 'styled-components';
import Img from 'react-image';

export const Button = styled.button`
  padding: 5px 25px;
  background-image: linear-gradient(116deg, #08aeea 0%, #2af598 100%);
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  font-family: sans-serif;
  filter: hue-rotate(0deg);
  transition: filter 300ms linear;
  cursor: pointer;
  &:focus,
  &:hover {
    filter: hue-rotate(45deg);
  }
`;

export const EpisodeCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const ProgramCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  border-radius: 1%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`;

export const CardImage = styled(Img)`
  border-radius: 1%;
  margin: 0;
  vertical-align: bottom;
`;

export const HorizontalScrollWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const DownloadButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  max-width: 600px;
`;

export const LogoImage = styled.img`
  height: 30px;
  @media screen and (max-width: 650px){
    height: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/styledComponents/theme.js